/**
 * sessionStorage key AppShell's onSignOut (in App.tsx) sets right before calling
 * logoutRedirect(), and App.tsx's `signedOut` gate reads to decide whether to
 * render the passive <SignedOut/> screen instead of re-entering
 * <MsalAuthenticationTemplate> (which would auto-redirect back into Entra —
 * the sign-out loop). Single source of truth so the writer (AppShell's
 * onSignOut) and reader (App()'s `signedOut` gate) can't drift apart.
 *
 * sessionStorage (not localStorage): per-tab, matching MSAL's own cache scope
 * (msalConfig.ts), so one tab's marker can't be cleared by another tab. It
 * still survives the same-tab logout -> Entra -> back redirect round-trip —
 * that's a single top-level browsing context the whole way, which is exactly
 * how MSAL's own sessionStorage cache survives the same trip.
 *
 * This is the console's OWN copy of the constant — mirrors, but is not
 * imported from, apps/portal/src/auth/signedOutMarker.ts. The two shells are
 * independent deployments (same precedent as msalConfig.ts's per-shell
 * duplication), so each keeps its own copy of the literal.
 */
export const SIGNED_OUT_KEY = 'viq_signed_out';
